import { render, staticRenderFns } from "./DownloadView.vue?vue&type=template&id=dfe6fb82&scoped=true"
import script from "./DownloadView.vue?vue&type=script&lang=js"
export * from "./DownloadView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe6fb82",
  null
  
)

export default component.exports